<i18n src="../../locales/lang.json"></i18n>

<template>
  <ul class="fab-menu fab-menu-top fab-menu-top-right fab-menu-fixed plusmenu" style="z-index:1002" id="editProcedureMenu">
    <li>
      <button type="button" class="fab-menu-btn btn skin primary-button btn-float rounded-pill btn-icon" @click="doMainClick">
        <i class="fab-icon-open icon-plus3"></i>
        <i class="fab-icon-close icon-cross2"></i>
      </button>
    </li>
      <draggable v-bind="dragOptions" class="fab-menu-inner" filter=".ignore-elements" v-model="storedElements" :move="checkMove" :group="{ name: 'description', pull: 'clone' }" tag="ul" @start="dragStart" @end="dragEnd" :clone="cloneElement" @update="dragUpdated">
      <li v-for="(element, index) in storedElements" :key="element.Id" v-bind:class="element.class" >
        <a  class="btn btn-light rounded-pill btn-icon btn-float menubutton" v-bind:data-index="index" data-popup="popover" data-trigger="hover" title="" data-delay="600" data-animation="false" data-placement="left" v-bind:data-original-title="element.Name">
          <i v-bind:class="element.Icon" @tap="test"></i>
        </a>
      </li>
      </draggable>
  </ul>
</template>

<script>

  import draggable from "vuedraggable";
  let idGlobal = -5;
  var dragging = false;

  let storedElements = [];

  export default {
    name: "draggable-menu",
    components: {
      draggable
    },
    data() {
      return {
        storedElements,
        idGlobal,
        dragging
      };
    },
    computed: {
      dragOptions() {
        return {
          selectedClass: "selectedClass",
          ghostClass: "ghostClass",
          chosenClass: "dropTargetClass",
          dragClass: "draggedClass",
          toggleClass: "toggleClass",
          sort:false
        };
      },
      elements: {
        get() {
          return this.storedElements;
        }
      }
    },

    methods: {
      test() {
        //alert('test');

      },

      addElementByClick() {

      }
      ,
      doClick(element, e) {

        //e.stopPropagation();
        this.idGlobal = this.idGlobal - 1;
        var copy = {
          "Id": element.Id,
          "Name": element.Name,
          "Icon": element.Icon,
          "ElementType": element.ElementType,
          "Text": element.Text,
          "class": element.class,
          "onclick": element.onclick,
          "Elements": element.Elements,
          "Settings": element.Settings,
          "OverRidable": element.OverRidable,
        }
        copy.Id = this.idGlobal;
        vm.$root.$emit('procedure_add_element', copy);
        this.$store.markAsChanged();
      },
      doMainClick(e) {
        e.preventDefault();
        vm.$root.$emit('check_if_procedure_editor_is_closable');
        
      },
      getSettings() {
       return { name: 'people', pull: 'clone', put: false }
      },

      onDragMove: function onDragMove(evt) {
        
        return onMove(evt);
      },
      handleChange() {
        //alert('changed');
      },
      inputChanged(value) {
        this.activeNames = value;
      },

      getComponentData() {
        return {
          on: {
            change: this.handleChange,
            input: this.inputChanged
          },
          attrs: {
            wrap: true,
            test: 'olle'
          },
          props: {
            value: this.activeNames,
            value2: 'bertil'
          },
          test: "testing"
        };
      },
      checkMove: function (evt, someother) {
        if (this.dragging == false)
          hideAllToolTips();
        this.dragging = true;
        return true;
      },
      move() {
        return false;
      },
      handleChange(event) {
        return false;
        //alert('val:' + JSON.stringify(val));
        //$(event.clone).html('<div>Bar X - starting</div>');
        //event.clone = $('<div>Bar X - starting</div>')[0];
        //$(event.clone).replaceWith($('<div>Bar X - starting</div>'))
        //$(event.ghost).replaceWith($('<div>Bar X - starting</div>'))
      },
      inputChanged(event) {
        //alert('some input change');
        //window.console.log(evt);
        //$(event.clone).replaceWith($('<div>Bar X - starting</div>'))
        //$(event.item).replaceWith($('<div>Bar X - starting</div>'))
      },
      log: function (evt) {
        //window.console.log(evt);
      },
      cloneElement({ Id, ElementType, OverRidable, Settings }) {
        return {
          Id: --this.idGlobal,
          TaskId: -1,
          Name: 'Add a name',
          Text: "",
          ElementType: ElementType,
          Settings: Settings,
          OverRidable: OverRidable,
          Elements: [],
          Url: "",
          IsChanged: true,
          ParentId: null
        };
      },
      dragStart(event) {
        
        //$(event.dragged).replaceWith($('<div>Bar X - starting</div>'))
      },

      dragEnd(event) {
        this.dragging = false;
      },
      dragUpdated(event) {
        //this.$root.$emit('stoppedDragging');
        return false;
      },
      dragCloned(event) {
      },
      dragSorted(event) {

      },
      dragMoved(event) {

      },
      dragAdded(event) {

      },

      addItem(event) {
      }

    },
    mounted() {

      this.storedElements = [
        {
          "Id": -1,
          "Name": this.$t('text'),
          "Icon": "icon-typography",
          "ElementType": 1,
          "Text": "",
          /*"class": "ignore-elements",*/
          "class": null,
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": false,
        },
        {
          "Id": -2,
          "Name": this.$t('task'),
          "Icon": "icon-checkbox-checked",
          "ElementType": 2,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": true,
        },
        {
          "id": -3,
          "Name": this.$t('image_or_file'),
          "Icon": "icon-attachment",
          "ElementType": 0,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": false,
        },
        {
          "id": -4,
          "Name": this.$t('section'),
          "Icon": "icon-indent-increase2 ",
          "ElementType": 4,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": false,
        },
        {
          "id": -5,
          "Name": this.$t('user_upload'),
          "Icon": "icon-upload4",
          "ElementType": 5,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": true
        },

        {
          "id": -6,
          "Name": this.$t('user_text'),
          "Icon": "icon-pencil5  ",
          "ElementType": 6,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": true,
        },
        {
          "id": -7,
          "Name": this.$t('user_long_text'),
          "Icon": "icon-pencil6 ",
          "ElementType": 7,
          "Text": "",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": true
        }
        ,
        {
          "id": -8,
          "Name": this.$t('user_select'),
          "Icon": "icon-list ",
          "ElementType": 8,
          "Text": "Select a value",
          "class": "",
          "onclick": null,
          "Elements": [],
          "Settings": null,
          "OverRidable": true
        }
      ];


      var thisContext = this;

      $(document).ready(function () {
        $(document).on("click touchend", ".menubutton", function () {
          var index = $(this).data("index");
          var element = thisContext.storedElements[parseInt(index)];
          if (thisContext.dragging == false) {
            setTimeout(function () {
              thisContext.doClick(element);
            }, 200)
          }
        });
      });

     

    }
  };

</script>

<style>

  .fab-menu-inner .dropTargetClass .btn {
    color: orange !important;
  }

  .selectedClass .btn {
    color: pink !important;
  }

  .fab-menu-inner .ghostClass .btn {
    color: darkmagenta !important;
  }

  .draggedClass .btn {
    color: green !important;
  }

  .toggleClass .btn {
    color: blue !important;
  }

 

</style>



// WEBPACK FOOTER //
// src/components/procedure/draggable-menu.vue